import React from 'react'

const Sco = () => {
  return (
    <div>Sco</div>
  )
}

export default Sco